// extracted by mini-css-extract-plugin
module.exports = {"fileDetail":"file-show--fileDetail--2V1HDHt"};